import { Flex, PrimarySecondaryPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";
import { OnboardingStepper } from "onboarding";

import { DocumentUploadSupportingContent } from "../../../components";
import { useDocumentQuery } from "../../../queries/document-uploads/queries";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import { DocumentNavigationGroup, SusaDocumentUpload } from "../components";

export const SusaDocumentUploadPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationData } = useFundingApplication(customerDomain);
  const { data: uploadedDocuments } = useDocumentQuery(customerDomain, fundingApplicationData.id);
  const hasUploadedDocuments = !!uploadedDocuments?.filter((doc) => doc.documentType === UploadDocumentType.SUSA)
    .length;

  const SusaDocumentUploadPrimary = (
    <Flex direction="column" gap="8">
      <SusaDocumentUpload />
      <DocumentNavigationGroup isStepComplete={hasUploadedDocuments} forType={UploadDocumentType.SUSA} />
    </Flex>
  );

  return (
    <PrimarySecondaryPage
      titleSlot={<OnboardingStepper currentStep={4} />}
      showStepperBackground={true}
      title={intl.formatMessage({
        id: "funding-application: upload company susa",
        defaultMessage: "Upload your company SUSA",
      })}
      primaryContent={SusaDocumentUploadPrimary}
      secondaryContent={<DocumentUploadSupportingContent />}
    />
  );
};
